<mat-dialog-content style="overflow: hidden;padding: 0px !important;">
<div class="py-4">
  <ng-container *ngIf="!this.data.actions && this.data.type != 'collect'">
    <div class="dialog-close-button">
      <button mat-icon-button (click)="this.dialogRef.close()" tabindex="-1" class="p-0">
        <img src="./assets/media/icons/close-icon.png" alt="">
      </button>
    </div>
  </ng-container>
  <div class="dialog-container px-5">
    <div class="dialog-icon mb-3">
      <img [src]="icon" alt="Icono">
    </div>
    <ng-container *ngIf="this.data.title">
      <div class="dialog-tittle text-capitalize text-center" [ngClass]="color">
        {{this.data.title}}
      </div>
    </ng-container>
    <ng-container *ngIf="this.data.text">
      <div class="dialog-subtitle mt-1 text-center">
        <div class="dialog-subtitle text-center" [innerHTML]="data.text"></div>
      </div>
    </ng-container>
  </div>
</div>
</mat-dialog-content>
<ng-container *ngIf="this.data.actions">
  <mat-dialog-actions>
    <button mat-button (click)="onCancel()">No</button>
    <button mat-button (click)="onConfirm()">Si</button>
  </mat-dialog-actions>
</ng-container>
